<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container-fluid">
        <div class="page-title-content">
            <h2 data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">WhatsApp Meta</h2>
            <ul data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>WhatsApp Meta</li>
            </ul>
        </div>
    </div>

</div>
<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">

                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/approved.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-sm-2 ">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Trusted WhatsApp Marketing
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Send bulk messages with confidence and compliance.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 order-lg-1  order-md-1 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Engage on WhatsApp at Scale
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 15px ;
                            ">
                            Drive results with the official bulk message sender. </p>
                       




                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-2 orde order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/WhatsApp-Scale.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">



                <div class="media col-lg-5 col-md-6 col-sm-12  order-lg-1  order-md-1 order-sm-1">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/Trusted-Messaging.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12  order-lg-2  order-md-2 order-sm-2">
                    <div class="ai-solution-content">
                        <h3 style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            ">
                            Trusted Messaging, Powerful Results
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            ">
                           Leverage WhatsApp's reach with confidence.
                    </div>
                </div>
            </div>
        </div>
    </div>
    


    <div class="warpper container-fluid" style="padding-left: 180px ; padding-right: 180px;">
        <input class="radio" id="one" name="group" type="radio" checked>
        <input class="radio" id="two" name="group" type="radio">
        <input class="radio" id="three" name="group" type="radio">
        <div class="tabs">
            <label  >Features</label>
            <!-- <label class="tab" id="two-tab" for="two">Promotional Messages</label>
            <label class="tab" id="three-tab" for="three">Informational Messages</label> -->
        </div>
        <div class="panels">
            <div class="panel" id="one-panel">
                <div class="row mt-5 mt-md-3 row-cols-1 row-cols-sm-1 row-cols-md-3 justify-content-center">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-key"></i>
                            </div>

                            <p>
                                Approved and safer route, offering more features and future-proofing your communication
                                strategy to send bulk messages.
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-arrows-down-to-people"></i>
                            </div>

                            <p>
                                Fully adheres to WhatsApp's Terms of Service and user consent regulations. </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="service-card">
                            <div class="icon-wrapper">
                                <i class="fa-solid fa-shopping-cart"></i>
                            </div>
                            <h3> Personalization at Scale</h3>
                            <p>
                                Offers a safe and reliable way to send bulk messages with features like:
                            </p>
                            <ul style="display: flex;
                            flex-wrap: wrap; color:#4c118e
                        ">
                                <li style="width: 222px;">
                                    Message scheduling
                                </li>
                                <li style="width: 222px;">
                                    Analytics
                                </li>
                                <li style="width: 222px;">
                                    Personalization
                                </li>
                                <li style="width: 222px;">
                                    Integration with other platforms
                                </li>
                            </ul>
                        </div>
                    </div>


                </div>
            </div>

        </div>
    </div>





</section>
<div class="full-row" #seprator id="seprator">
    <div class="container-fluid">
        <h6>
            To know about pricing

        </h6>
        <a class="btns btn-primarys" routerLink="/contact">
            CONTACT US
        </a>
    </div>
</div>